import React, { useState } from "react";
import { API_URL } from "../../ai/environment";

// R33 (I1-013): the undo link mailed to the old address after an email change. The change is
// undone only on an explicit click (mail scanners that open links never trigger it).
// R34: the code arrives in the URL fragment (never sent to a server) and is removed from the
// address bar and history at once; R33 links (?code=) still work.
function takeCode() {
  const fromHash = new URLSearchParams(window.location.hash.replace(/^#/, "")).get("code");
  const code = fromHash || new URLSearchParams(window.location.search).get("code") || "";
  if (code) window.history.replaceState(null, "", window.location.pathname);
  return code;
}
export default function UndoEmail() {
  const [code] = useState(takeCode);
  const [state, setState] = useState("ready");
  const undo = async () => {
    setState("working");
    try {
      const response = await fetch(API_URL + "/auth/email-undo", { method: "POST", headers: { "Content-Type": "application/json" }, referrerPolicy: "no-referrer", body: JSON.stringify({ code }) });
      setState(response.ok ? "done" : response.status === 409 ? "conflict" : response.status === 400 ? "invalid" : response.status === 403 ? "admin" : "unavailable");
    } catch (_) { setState("unavailable"); }
  };
  const messages = {
    done: "The change was undone. Every device was signed out. Reset your password before you sign in again.",
    conflict: "That address now belongs to another account. Contact support.",
    invalid: "This link is invalid, expired or has already been used.",
    unavailable: "Undo is temporarily unavailable. Please try again shortly.",
    // R35 (decision C6-030): an administrator's change is reversed by an administrator only.
    admin: "This change was made by a Stratic administrator. Contact Stratic support; an administrator can reverse it after confirming who you are.",
  };
  return (
    <div style={{ maxWidth: 480, margin: "80px auto", padding: "0 16px", textAlign: "center" }}>
      <h1 style={{ fontSize: 28 }}>Undo email change</h1>
      {messages[state] ? <p role="status">{messages[state]}</p> : (
        <>
          <p>If you did not change your sign-in email address, undo it to restore your previous address and sign out every device.</p>
          <button type="button" onClick={undo} disabled={!code || state === "working"}>Undo this change</button>
        </>
      )}
    </div>
  );
}
